import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/box-locked.png'


const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content-box" }, "Loading...", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "content"
}
const _hoisted_5 = { class: "content-box" }
const _hoisted_6 = { class: "message error" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "counter" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "message"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "album" }
const _hoisted_17 = { class: "items" }
const _hoisted_18 = ["alt", "src"]
const _hoisted_19 = { class: "title" }
const _hoisted_20 = {
  key: 1,
  class: "item hidden"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  alt: "???",
  src: _imports_0
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "title hidden" }, "???", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "item-box"
}
const _hoisted_25 = { class: "item-image" }
const _hoisted_26 = ["alt", "src"]
const _hoisted_27 = { class: "item-details" }
const _hoisted_28 = { id: "item-name" }
const _hoisted_29 = { class: "item-from" }
const _hoisted_30 = {
  key: 0,
  class: "item-positions"
}
const _hoisted_31 = { class: "item-description" }
const _hoisted_32 = { class: "footer" }
const _hoisted_33 = ["datetime"]
const _hoisted_34 = {
  key: 1,
  class: "no-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.state === 'Loading')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.state === 'Error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.message), 1)
          ])
        ]))
      : (_ctx.state === 'Game')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "content-box",
                style: _normalizeStyle({height: _ctx.contentBoxHeight})
              }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.found), 1),
                  _createElementVNode("small", null, "/" + _toDisplayString(_ctx.items.length), 1)
                ]),
                (_ctx.found === _ctx.items.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Congratulations" + _toDisplayString(_ctx.username ? ' ' + _ctx.username : '') + "! You've collected all of the various items within The 'Shroom!", 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_10, "Hello" + _toDisplayString(_ctx.username ? ' ' + _ctx.username : '') + "! Have a gander at each of the items you have collected along the way! Try to collect them all!", 1)),
                _createElementVNode("p", null, [
                  _createTextVNode("Select an item to read more about it, or view the special 'Shroom section "),
                  _createElementVNode("a", {
                    href: _ctx.hubUrl,
                    target: "_blank"
                  }, "here", 8, _hoisted_11),
                  _createTextVNode(" for general information.")
                ]),
                _createVNode(_Transition, { name: "slide-up" }, {
                  default: _withCtx(() => [
                    (_ctx.message)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.message), 1))
                      : (_ctx.activeGameTitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("p", null, [
                              _createTextVNode("Note: you're currently playing "),
                              _createElementVNode("i", null, _toDisplayString(_ctx.activeGameTitle), 1),
                              _createTextVNode(" in this browser, you won't be able to find and collect items for this game. To resume playing "),
                              _createElementVNode("i", null, _toDisplayString(_ctx.title), 1),
                              _createTextVNode(", click the button below.")
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("button", {
                                class: "button",
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchGame && _ctx.switchGame(...args))),
                                disabled: _ctx.loading
                              }, "Resume", 8, _hoisted_15)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 4),
              _createElementVNode("main", _hoisted_16, [
                _createElementVNode("ul", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.id
                    }, [
                      (item.found)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            class: _normalizeClass(["item found", {new: !item.seen, selected: _ctx.selectedItem && _ctx.selectedItem.id === item.id}])
                          }, [
                            _createVNode(_component_router_link, {
                              to: {name: 'item', params:{itemId: item.id}}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  alt: item.name,
                                  src: `${_ctx.baseUrl}/images/${item.image}`
                                }, null, 8, _hoisted_18),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ], 2))
                        : (_openBlock(), _createElementBlock("li", _hoisted_20, _hoisted_23))
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["item-view", {'show-item': _ctx.selectedItem}])
            }, [
              (_ctx.selectedItem)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("img", {
                        alt: _ctx.selectedItem.name,
                        src: `${_ctx.baseUrl}/images/${_ctx.selectedItem.image}`
                      }, null, 8, _hoisted_26)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.selectedItem.name), 1),
                      _createElementVNode("p", _hoisted_29, "From: " + _toDisplayString(_ctx.selectedItem.from), 1),
                      (_ctx.selectedItem.positions?.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.selectedItem.positions.join('; ')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.selectedItem.description), 1),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("time", {
                          id: "item-date",
                          datetime: _ctx.selectedItem.foundAt
                        }, _toDisplayString(_ctx.selectedFoundAtDisplay), 9, _hoisted_33),
                        _createVNode(_component_router_link, {
                          to: {name: 'home'},
                          class: "close button",
                          title: "Close"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Close")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_34, "Select an item on the left to view it!"))
            ], 2)
          ], 64))
        : _createCommentVNode("", true)
}